module.exports = __webpack_public_path__ + "img/balloon_thumb.a36a8a0f.jpg";